"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingPageAlert = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const styles_1 = require("./styles");
const TrackingPageAlert = ({ active, children, title, onDismiss }) => {
    (0, react_1.useEffect)(() => {
        let timeoutID;
        if (active) {
            timeoutID = setTimeout(() => {
                onDismiss();
            }, 5000);
        }
        return () => timeoutID && clearTimeout(timeoutID);
    }, [active, onDismiss]);
    if (!active) {
        return null;
    }
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(polaris_1.Banner, { onDismiss: onDismiss, status: 'success', title: title }, children)));
};
exports.TrackingPageAlert = TrackingPageAlert;
